<template>
  <div>
    <app-bar ref="refAppBar" @updated="updated"></app-bar>
    <v-card elevation="0">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="（キーワード検索）"
          single-line
          hide-details
          clearable
          dense
        ></v-text-field>
      </v-card-title>
      <!-- テーブル -->
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        item-key="id"
        :mobile-breakpoint="0"
        :sort-desc="['date']"
        :items-per-page="100"
        :footer-props="{
          'items-per-page-options': [100, 200, 400, -1],
          'items-per-page-text': '表示件数',
        }"
      >
        <!-- eslint-disable-next-line -->
        <template v-slot:footer.page-text="props">
          {{ props.pageStart }} ～{{ props.pageStop }}件／全{{
            props.itemsLength
          }}件
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.edit="{ item }">
          <v-icon class="pa-1" @click="editItem(item)"> mdi-pencil </v-icon>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.delete="{ item }">
          <v-icon class="pa-1" @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:no-data> 表示するデータがありません </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  defineComponent,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import appBar from "./appBar.vue";
import selectItem from "@/common/selectItem.js";

export default defineComponent({
  components: {
    appBar,
  },
  setup(_, ctx) {
    const informationsRepository = repositoryFactory.get("informations");
    const refAppBar = ref();
    const state = reactive({
      search: "",
      headers: [
        {
          text: "編集",
          value: "edit",
          sortable: false,
          align: "center",
          width: 60,
        },
        {
          text: "お知らせ日",
          value: "date",
          sortable: true,
          class: "td_date",
        },
        {
          text: "タイトル",
          value: "title",
          sortable: true,
          class: "td_title",
        },
        {
          text: "内容",
          value: "content",
          sortable: true,
          class: "td_content",
        },
        {
          text: "種別",
          value: "type_name",
          sortable: true,
          class: "td_type_name",
        },
        {
          text: "削除",
          value: "delete",
          sortable: false,
          align: "center",
          width: 60,
        },
      ],
      desserts: [], // DataTablesレコード格納用
    });

    const editItem = (user) => {
      // ダイアログ開く
      refAppBar.value.action({
        action: "edit",
        value: user.id,
      });
    };

    // データ削除
    const deleteItem = async (item) => {
      if (window.confirm("削除してよろしいですか？")) {
        store.dispatch("loadingIcon/showIcon"); // ローディング表示

        // 削除処理
        await informationsRepository
          .admin_delete(item.id)
          .then((response) => {
            if (response.data) {
              // データ削除OK
              alert(`「${item.name}」が削除されました。`);
            }
          })
          .catch((error) => {
            throw (
              "ERROR:admin/user/index.vue/onSubmit informationsRepository.admin_delete (" +
              error +
              ")"
            );
          });

        init();

        store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
      }
    };

    // 初期化処理(同期処理)
    const init = async () => {
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      state.desserts.splice(0);
      await informationsRepository
        .admin_list()
        .then((response) => {
          if (response.data) {
            Object.keys(response.data).forEach(function (key) {
              const tmp = response.data[key];
              set(
                tmp,
                "type_name",
                selectItem.informationTypeItem.find(
                  (x) => x.value === response.data[key].type
                ).text
              );
              state.desserts.push(tmp);
            });
          }
        })
        .catch((error) => {
          throw (
            "ERROR:admin/user/index.vue/onSubmit informationsRepository.admin_list (" +
            error +
            ")"
          );
        });

      store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
    };

    init();

    const updated = (user_data) => {
      init();
    };

    // 返却オブジェクト定義
    return {
      refAppBar,
      selectItem,
      setting,
      ...toRefs(state),
      editItem,
      deleteItem,
      init,
      updated,
    };
  },
});
</script>
<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  padding: 0 6px !important;
}
</style>
